import React, {useState} from "react";
import Input from "../../../react/components/ui/spectre/Input";
import {useTranslationContext} from "../../../react/providers/TranslationContext";
import {FormatDateTime} from "../../../helper/dateTime";
import {useV2Data} from "../../../react/hooks/useData";

type ArchiveRow = {
    id: number,
    uuid: string,
    url: string,
    name: string,
    timestamp: number,
    filesize: number,
    datafrom: number,
    contentHash: string,
    datafromdate: string,
}

export default function TravianMapSql() {
    const [searchQuery, setSearchQuery] = useState<string>('');

    const { data } = useV2Data<ArchiveRow[]>('travian/mapSqlArchive', { query: searchQuery }, data => Object.values(data));

    const translate = useTranslationContext().getTranslator('page/travianMapSql');

    return <div>
        <div className='bg-dark p-2 mb-2'>
            <div>{translate('info')}</div>
            <div>
                You can also use the API, if you need to fetch larger amounts:
                <pre>
                    GET /api/v2/travian/mapSqlArchive?query=&lt;server uuid or url&gt;
                </pre>
                To receive a list of map.sql files I have for that server. I'd recommend using the server's UUID, as URLs are ambiguous between restarts of the same server. I don't have the UUIDs for servers before ~end of 2022 though, so URL will have to suffice.

                <pre>
                    GET /api/v2/travian/mapSqlArchive/&lt;server uuid&gt;/&lt;date&gt;<br />
                    GET /api/v2/travian/mapSqlArchive/&lt;archive id&gt;
                </pre>
                To receive the map.sql by either it's archive id, which you can get from the query request above, or by it's UUID + date. If I don't have the data, you'll get a 404.

                <div className='mt-2'>
                    Please don't rely on this to receive data from in-game, as you may see when playing around a bit, I'm missing a fair bit of data myself, so it's not the most reliable service. But it's nice if I happen to have a file or two you missed, or if you started fetching the map.sql only late into the server. :)
                </div>
            </div>
        </div>

        <Input onChange={(e) => setSearchQuery(e.target.value.trim())} placeholder={translate('searchPlaceholder')} />

        <div className='my-2'>
            { data && <>Showing <b>{data.length > 500 ? 500 : data.length}</b> results. {data.length > 500 ? 'More results are available through the API.' : ''}</> || <>Loading ...</> }
        </div>

        <table width="100%">
            <thead>
            <tr className='text-left'>
                <th>{translate('colId')}</th>
                <th>{translate('colUuid')}</th>
                <th>{translate('colUrl')}</th>
                <th>{translate('colName')}</th>
                <th>{translate('colDataFrom')}</th>
                <th>{translate('colTimestamp')}</th>
                <th>{translate('colDownloadPath')}</th>
                <th>{translate('colHash')}</th>
            </tr>
            </thead>
            <tbody>
            {data && data.slice(0, 500).map(row => <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.uuid}</td>
                <td>{row.url}</td>
                <td>{row.name}</td>
                <td>{FormatDateTime(row.datafrom)}</td>
                <td>{FormatDateTime(row.timestamp)}</td>
                <td><a href={`/api/v2/travian/mapSqlArchive/` + (row.uuid ? `${row.uuid}/${row.datafromdate}` : row.id)} target='_blank'>{translate('download')}</a></td>
                <td>{row.contentHash ? row.contentHash.substring(0, 16) + "..." : 'N/A'}</td>
            </tr>)}
            </tbody>
        </table>
    </div>
}
